import TirPmCropper from "./src/TirPmCropper.vue";
export default TirPmCropper;
export { TirPmCropper };
export { default as TirCropperPreview } from "./src/TirPmCropperPreview.vue";
export * from "./src/style";
export * from "./src/models";
